import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { IconComponent } from "@optee/ui/components/icon/icon.component";

@Component({
  selector: "swc-extended-card",
  host: {
    class:
      "shadow-o bg-white flex items-center rounded-xl p-6 gap-5 xl:max-w-[536px]",
  },
  template: `
    <oui-icon
      class="text-primary-500 size-6 flex-shrink-0 lg:size-10"
      [svg]="icon()"
    />

    <p class="font-display text-primary-900">
      <ng-content />
    </p>
  `,
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtendedCardComponent {
  icon = input.required<string>();
}
